import _Progress from './Progress';

import './style/index.js';

export * from './type';

export const Progress = _Progress;

export default Progress;
